import React, { useState } from 'react'
import { Dialog, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useBoolState } from '../../../../hooks/commonHooks'
import { CategoriesSelector } from './categoriesSelector'
import { CategoryDisplay } from './categoriesDisplay'
import { Button } from '../../../shared/ui/button'
import { useFormStyles } from '../../../shared/lib/hooks/useFormStyles'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { TFormValues } from '../productForm.types'
import { AttributeField } from './attributeField'
import { useLogic } from '../../../../hooks/storeHook'

type MainFieldsProps = {
  showGenerateButton?: boolean
}

export const MainFields = ({ showGenerateButton = false }: MainFieldsProps) => {
  const classes = useStyles()
  const formClasses = useFormStyles()
  const logic = useLogic()

  const { control, getValues, setValue } = useFormContext<TFormValues>()
  const [isGenerating, setIsGenerating] = useState(false)

  const {fields} = useFieldArray({
    control,
    name: 'attributes',
    keyName: '_id'
  })

  const mainFields = fields.filter(attr => !attr.integrationType && attr.name)

  const [isCategoryModalOpen, setCategoryModalOpen, setCategoryModalClose] = useBoolState(false)

  const descriptionAttr = getValues('description')

  const handleGenerateBarcode = async (attrIndex: number) => {
    setIsGenerating(true)
    try {
      const barcodes = await logic.handleBarcodesWB()
      if (barcodes.length > 0) {
        setValue(`attributes.${attrIndex}.currentValue`, barcodes[0])
      }
    } catch (error) {
      console.error('Ошибка генерации баркода:', error)
    } finally {
      setIsGenerating(false)
    }
  }

  return <>
    <Typography variant="h1" color="primary" gutterBottom className={classes.title}>
      Основная информация
    </Typography>
    <Grid container spacing={2} className={classes.gridContainer}>

      <Grid item xs={6}>
        <CategoryDisplay onClickHandler={setCategoryModalOpen}/>
      </Grid>

      {mainFields.map((attr, index: number) => {
        const isSmall = index >= mainFields.length - 8
        const globalIndex = fields.findIndex(f => f._id === attr._id)

        if (attr.name === 'Баркод') {
          return (
            <Grid item xs={isSmall ? 3 : 6} key={attr._id}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs>
                  <AttributeField
                    attr={attr}
                    name={`attributes.${globalIndex}.currentValue`}
                    as={attr.enumValues?.length > 0 ? 'autoselect' : 'input'}
                  />
                </Grid>
                {showGenerateButton  && (
                  <Grid item>
                    <Button
                      type="button"
                      onClick={() => handleGenerateBarcode(globalIndex)}
                      disabled={isGenerating}
                    >
                      {isGenerating ? 'Генерация...' : 'Сгенерировать'}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          )
        }

        return (
          <Grid item xs={isSmall ? 3 : 6} key={attr._id}>
            <AttributeField attr={attr} name={`attributes.${globalIndex}.currentValue`}
                            as={attr.enumValues?.length > 0 ? 'autoselect' : 'input'}/>
          </Grid>
        )
      })}


      {descriptionAttr && (
        <Grid item xs={12}>
          <AttributeField
            name="description.currentValue"
            attr={descriptionAttr}
            as="textArea"
          />
        </Grid>
      )}

    </Grid>

    <Dialog
      open={isCategoryModalOpen}
      onClose={setCategoryModalClose}
      PaperProps={{
        style: {
          maxWidth: 'none',
          borderRadius: 12,
          background: 'white',
          boxShadow: 'none',
          padding: '30px',
          width: 800
        }
      }}
    >
      <CategoriesSelector/>
      <Button type={'button'} onClick={setCategoryModalClose} className={formClasses.button}>Добавить</Button>
    </Dialog>
  </>
}

const useStyles = makeStyles(
  {
    title: {fontWeight: 600, fontSize: '19px', margin: '20px 0'},
    gridContainer: {marginBottom: '20px'}
  })
